<template>
  <div class="messages-root">
    <button
      v-if="!sidebarOpen"
      type="button"
      class="messages-tab"
      title="Apri Messaggi"
      aria-label="Apri Messaggi"
      @click="toggleSidebar"
    >
      <span class="messages-tab-icon" aria-hidden="true">
        <i class="fa-solid fa-bell"></i>
        <span v-if="numeroMessaggiNonLetti > 0" class="messages-count">
          {{ numeroMessaggiNonLetti }}
        </span>
      </span>
      <span class="messages-tab-label">Messaggi</span>
      <i class="fa-solid fa-chevron-left messages-tab-chevron"></i>
    </button>

    <transition name="messages-backdrop">
      <button
        v-if="sidebarOpen"
        type="button"
        class="messages-backdrop"
        aria-label="Chiudi Messaggi"
        @click="closeSidebar"
      ></button>
    </transition>

    <transition name="messages-drawer">
      <aside
        v-if="sidebarOpen"
        class="messages-drawer"
        aria-label="Messaggi MyStudio"
      >
        <header class="messages-header">
          <div class="messages-heading-copy">
            <div class="messages-title-row">
              <span class="messages-heading-icon" aria-hidden="true">
                <i class="fa-solid fa-bell"></i>
              </span>
              <h3>Messaggi</h3>
              <span v-if="numeroMessaggiNonLetti > 0" class="header-count">
                {{ numeroMessaggiNonLetti }}
              </span>
            </div>
            <p>Notifiche, aggiornamenti e comunicazioni utili.</p>
          </div>
          <button
            type="button"
            class="messages-close"
            title="Chiudi Messaggi"
            aria-label="Chiudi Messaggi"
            @click="closeSidebar"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </header>

        <div class="messages-scroll-area">
          <section class="news-section-content">
            <div v-if="tutteNotifiche.length > 0" class="news-list-display">
              <article
                v-for="item in tutteNotifiche"
                :key="item.id + '-' + item.tipoNotifica"
                :class="[
                  'message-card',
                  item.tipoNotifica === 'news'
                    ? 'message-card-news'
                    : 'message-card-notification',
                  { 'non-letta': !item.letto },
                  {
                    'active-news':
                      modalNews &&
                      item.id === activeNewsId &&
                      item.tipoNotifica === modalNews.tipoNotifica,
                  },
                ]"
                @click="vaiA(item)"
              >
                <span
                  class="message-card-icon"
                  :class="[
                    item.tipoNotifica === 'news'
                      ? 'message-card-icon-news'
                      : 'message-card-icon-notification',
                    item.tipoNotifica === 'news'
                      ? `message-type-${item.message_type || 'notizia'}`
                      : '',
                  ]"
                  aria-hidden="true"
                >
                  <i
                    :class="
                      item.tipoNotifica === 'news'
                        ? getIconClass(item.message_type)
                        : 'fa-solid fa-envelope'
                    "
                  ></i>
                </span>

                <div class="message-card-content">
                  <div class="message-card-heading">
                    <h4>{{ item.title }}</h4>
                    <time :datetime="item.updated_at || item.created_at">
                      {{ formatDate(item.updated_at || item.created_at) }}
                    </time>
                  </div>
                  <span class="message-source">
                    {{
                      item.tipoNotifica === "news"
                        ? "MyStudio"
                        : "Notifica dello studio"
                    }}
                  </span>
                  <p>{{ breveContenuto(item.content) }}</p>
                  <button
                    v-if="
                      item.content &&
                      (item.tipoNotifica === 'news' ||
                        item.content.length > limiteCaratteri)
                    "
                    type="button"
                    class="btn-leggi-di-piu"
                    @click.stop="apriModal(item)"
                  >
                    Continua a leggere
                    <i class="fa-solid fa-arrow-right"></i>
                  </button>
                </div>

                <button
                  v-if="item.tipoNotifica === 'notifica'"
                  type="button"
                  class="notification-delete"
                  title="Elimina notifica"
                  aria-label="Elimina notifica"
                  @click.stop="eliminaNotifica(item.id)"
                >
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </article>
            </div>

            <div v-else class="no-news-display">
              <span aria-hidden="true">
                <i class="fa-regular fa-bell"></i>
              </span>
              <h4>Nessun messaggio</h4>
              <p>Quando ci saranno novità o notifiche, le troverai qui.</p>
            </div>
          </section>
        </div>
      </aside>
    </transition>

    <div
      v-if="modalNews"
      class="modal-overlaynews"
      role="dialog"
      aria-labelledby="modal-title"
      aria-modal="true"
      @click.self="chiudiModal"
    >
      <div class="modal-contentnews">
        <button
          type="button"
          class="modal-close-icon"
          aria-label="Chiudi messaggio"
          @click="chiudiModal"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <span class="modal-label">
          {{
            modalNews.tipoNotifica === "news"
              ? "Comunicazione MyStudio"
              : "Notifica dello studio"
          }}
        </span>
        <h3 id="modal-title">{{ modalNews.title }}</h3>
        <p>{{ modalNews.content }}</p>
        <small>
          {{ formatDate(modalNews.updated_at || modalNews.created_at) }}
        </small>
        <button type="button" class="btn-chiudinews" @click="chiudiModal">
          Chiudi
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/config.js";

export default {
  name: "NewsSection",
  data() {
    return {
      sidebarOpen: false,
      modalNews: null,
      activeNewsId: null,
      limiteCaratteri: 135,
      newsItems: [],
      notificheStudio: [],
      notificheViste: [],
      iconMap: {
        notizia: "fa-solid fa-newspaper",
        aggiornamento: "fa-solid fa-gear",
        alert: "fa-solid fa-triangle-exclamation",
        evento: "fa-solid fa-calendar-days",
      },
    };
  },
  computed: {
    numeroNotizieNonLette() {
      return this.newsItems.filter((n) => !n.letto).length;
    },
    numeroNotificheNonLette() {
      return this.notificheStudio.filter((n) => !n.letto).length;
    },
    numeroMessaggiNonLetti() {
      return this.numeroNotizieNonLette + this.numeroNotificheNonLette;
    },
    tutteNotifiche() {
      const pinnedNews = this.newsItems.map((n) => ({
        ...n,
        tipoNotifica: "news",
      }));
      const userNotifiche = this.notificheStudio.map((n) => ({
        ...n,
        tipoNotifica: "notifica",
      }));
      return [...pinnedNews, ...userNotifiche];
    },
  },
  mounted() {
    localStorage.removeItem("sidebarHidden");
    document.addEventListener("keydown", this.handleKeydown);
    this.fetchDati();
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    getIconClass(type) {
      return this.iconMap[type] || "fa-solid fa-bell";
    },
    async fetchDati() {
      await Promise.all([this.fetchNews(), this.fetchNotificheStudio()]);
    },
    async fetchNews() {
      try {
        const response = await axios.get(`${API_BASE_URL}/public-news`);
        this.newsItems = response.data;
      } catch (err) {
        console.error(err);
        this.newsItems = [];
      }
    },
    async fetchNotificheStudio() {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/user-studio-notifications`
        );
        this.notificheStudio = response.data.map((n) => ({
          id: n.id,
          title: n.tipo || "Notifica",
          content: n.contenuto || "",
          link: n.link || "",
          invito_id: n.invito_id || null,
          created_at: n.created_at,
          updated_at: n.updated_at || n.created_at,
          stato: n.stato,
          letto: n.stato === "letto",
        }));
        this.applicaStatoLettoNotifiche();
      } catch (err) {
        console.error(err);
        this.notificheStudio = [];
      }
    },
    applicaStatoLettoNotifiche() {
      for (const n of this.notificheStudio) {
        n.letto = n.stato === "letto" || this.notificheViste.includes(n.id);
      }
    },
    toggleSidebar() {
      if (this.sidebarOpen) {
        this.closeSidebar();
        return;
      }
      this.sidebarOpen = true;
      this.fetchDati();
    },
    closeSidebar() {
      if (!this.sidebarOpen) return;
      this.sidebarOpen = false;
      Promise.all([
        this.segnaTutteNotizieVisibiliComeLette(),
        this.segnaTutteNotificheVisibiliComeLette(),
      ]).finally(() => this.fetchDati());
    },
    handleKeydown(event) {
      if (event.key === "Escape") {
        if (this.modalNews) this.chiudiModal();
        else this.closeSidebar();
      }
    },
    breveContenuto(text) {
      if (!text) return "";
      return text.length > this.limiteCaratteri
        ? `${text.substring(0, this.limiteCaratteri)}…`
        : text;
    },
    formatDate(date) {
      if (!date) return "—";
      const parsedDate = new Date(date);
      if (Number.isNaN(parsedDate.getTime())) return "—";
      return parsedDate.toLocaleDateString("it-IT", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    },
    apriModal(news) {
      this.modalNews = news;
      this.activeNewsId = news.id;
      if (!news.letto) {
        news.letto = true;
        if (news.tipoNotifica === "news") {
          this.segnaTutteNotizieVisibiliComeLette();
        } else {
          this.segnaTutteNotificheVisibiliComeLette();
        }
      }
    },
    chiudiModal() {
      this.modalNews = null;
      this.activeNewsId = null;
    },
    isDismissibleNotification(notifica) {
      if (!notifica || notifica.tipoNotifica !== "notifica") {
        return false;
      }

      const dismissibleTitles = ["Invito accettato", "Invito rifiutato"];
      return dismissibleTitles.includes(notifica.title);
    },
    isInvitationNotification(notifica) {
      return (
        notifica &&
        notifica.tipoNotifica === "notifica" &&
        notifica.title === "Invito ricevuto" &&
        notifica.link &&
        notifica.invito_id
      );
    },
    buildInvitationRoute(notifica) {
      return {
        path: notifica.link,
        query: {
          ...this.$route.query,
          openShare: "1",
          invito: String(notifica.invito_id),
        },
      };
    },
    async vaiA(notifica) {
      if (this.isDismissibleNotification(notifica)) {
        await this.eliminaNotifica(notifica.id, { silent: true });
        return;
      }

      if (this.isInvitationNotification(notifica)) {
        const route = this.buildInvitationRoute(notifica);
        if (
          this.$route.path !== route.path ||
          this.$route.query.openShare !== route.query.openShare ||
          this.$route.query.invito !== route.query.invito
        ) {
          await this.$router.push(route).catch((error) => {
            if (!error || error.name !== "NavigationDuplicated") {
              throw error;
            }
          });
        }
        this.$root.$emit("open-share-modal", {
          invitoId: notifica.invito_id,
          link: notifica.link,
        });
        return;
      }

      if (notifica.link && this.$route.path !== notifica.link) {
        await this.$router.push(notifica.link);
      }
    },
    async eliminaNotifica(id, options = {}) {
      const { silent = false } = options;
      try {
        await axios.delete(`${API_BASE_URL}/user-studio-notifications/${id}`);
        this.notificheStudio = this.notificheStudio.filter((n) => n.id !== id);
      } catch (err) {
        console.error(err);
        if (err.response && err.response.status === 404) {
          this.notificheStudio = this.notificheStudio.filter(
            (n) => n.id !== id
          );
          return;
        }
        if (!silent) {
          alert("Errore nell'eliminare la notifica.");
        }
      }
    },
    async segnaTutteNotizieVisibiliComeLette() {
      const nonLette = this.newsItems.filter((n) => !n.letto);
      if (!nonLette.length) return;
      const backup = nonLette.map((n) => ({ id: n.id }));
      nonLette.forEach((n) => (n.letto = true));
      try {
        await axios.post(`${API_BASE_URL}/notizie-lette`, {
          notizie_ids: nonLette.map((n) => n.id),
        });
      } catch {
        backup.forEach((nb) => {
          const news = this.newsItems.find((n) => n.id === nb.id);
          if (news) news.letto = false;
        });
      }
    },
    async segnaTutteNotificheVisibiliComeLette() {
      const nonLette = this.notificheStudio.filter((n) => !n.letto);
      if (!nonLette.length) return;
      const backup = nonLette.map((n) => ({ id: n.id }));
      nonLette.forEach((n) => (n.letto = true));
      try {
        await axios.post(`${API_BASE_URL}/notifiche-lette`, {
          notifiche_ids: nonLette.map((n) => n.id),
        });
      } catch {
        backup.forEach((nb) => {
          const notif = this.notificheStudio.find((n) => n.id === nb.id);
          if (notif) notif.letto = false;
        });
      }
    },
  },
};
</script>

<style scoped>
.messages-root {
  --messages-green: #146f52;
  --messages-green-dark: #0f5d44;
  --messages-ink: #17243d;
  --messages-muted: #66778a;
  --messages-border: #dfe7e3;
}

.messages-tab {
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 1900;
  display: flex;
  width: 3rem;
  min-height: 10.5rem;
  padding: 0.75rem 0.35rem;
  box-sizing: border-box;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 0.65rem;
  transform: translateY(-50%);
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-right: 0;
  border-radius: 18px 0 0 18px;
  background: linear-gradient(180deg, #16815d 0%, var(--messages-green) 100%);
  box-shadow: -5px 7px 18px rgba(15, 63, 47, 0.2);
  color: #ffffff;
  cursor: pointer;
  font: inherit;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.messages-tab:hover {
  transform: translate(-2px, -50%);
  background: linear-gradient(180deg, #168862 0%, #12694d 100%);
  box-shadow: -7px 9px 21px rgba(15, 63, 47, 0.25);
}

.messages-tab:focus-visible,
.messages-close:focus-visible,
.notification-delete:focus-visible,
.btn-leggi-di-piu:focus-visible,
.btn-chiudinews:focus-visible {
  outline: 3px solid rgba(45, 156, 113, 0.28);
  outline-offset: 2px;
}

.messages-tab-icon {
  position: relative;
  display: inline-flex;
  width: 1.7rem;
  height: 1.7rem;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  font-size: 1rem;
}

.messages-count {
  position: absolute;
  top: -0.45rem;
  right: -0.45rem;
  display: inline-flex;
  min-width: 1.15rem;
  height: 1.15rem;
  padding: 0 0.22rem;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: 2px solid var(--messages-green);
  border-radius: 999px;
  background: #dc2945;
  color: #ffffff;
  font-size: 0.63rem;
  font-weight: 800;
  line-height: 1;
}

.messages-tab-label {
  font-size: 0.88rem;
  font-weight: 700;
  letter-spacing: 0.025em;
  writing-mode: vertical-rl;
}

.messages-tab-chevron {
  font-size: 0.68rem;
  opacity: 0.85;
}

.messages-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2090;
  padding: 0;
  border: 0;
  background: rgba(10, 20, 26, 0.34);
  cursor: default;
}

.messages-drawer {
  position: fixed;
  top: 5.75rem;
  right: 0;
  bottom: 0.75rem;
  z-index: 2110;
  display: flex;
  width: min(22rem, calc(100vw - 1rem));
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid var(--messages-border);
  border-right: 0;
  border-radius: 16px 0 0 16px;
  background: #ffffff;
  box-shadow: -16px 16px 38px rgba(16, 42, 53, 0.2);
  color: var(--messages-ink);
}

.messages-header {
  display: flex;
  flex: 0 0 auto;
  padding: 1.15rem 1rem 1rem 1.15rem;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.8rem;
  border-bottom: 1px solid #e6ece9;
  background: linear-gradient(135deg, #ffffff 45%, #f1f8f5 100%);
}

.messages-heading-copy {
  min-width: 0;
}

.messages-title-row {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.messages-heading-icon {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #e8f6ef;
  color: var(--messages-green);
  font-size: 0.9rem;
}

.messages-title-row h3 {
  margin: 0;
  color: #102a43;
  font-size: 1.25rem;
  font-weight: 750;
  line-height: 1.1;
}

.header-count {
  display: inline-flex;
  min-width: 1.35rem;
  height: 1.35rem;
  padding: 0 0.3rem;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 999px;
  background: #dc2945;
  color: #ffffff;
  font-size: 0.68rem;
  font-weight: 800;
}

.messages-heading-copy > p {
  margin: 0.45rem 0 0 2.55rem;
  color: var(--messages-muted);
  font-size: 0.78rem;
  line-height: 1.4;
  text-align: left;
}

.messages-close,
.notification-delete,
.modal-close-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.messages-close {
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
  border: 1px solid #dfe6e3;
  border-radius: 999px;
  background: #ffffff;
  color: #647386;
  font-size: 0.82rem;
  transition: background 0.18s ease, color 0.18s ease;
}

.messages-close:hover {
  background: #f1f4f3;
  color: #263b4b;
}

.messages-scroll-area {
  flex: 1 1 auto;
  min-height: 0;
  padding: 0.9rem;
  overflow-y: auto;
  scrollbar-color: #aab7b1 transparent;
  scrollbar-width: thin;
}

.messages-scroll-area::-webkit-scrollbar {
  width: 7px;
}

.messages-scroll-area::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #aab7b1;
}

.news-list-display {
  display: flex;
  flex-direction: column;
  gap: 0.72rem;
}

.message-card {
  position: relative;
  display: grid;
  grid-template-columns: 2.35rem minmax(0, 1fr);
  gap: 0.7rem;
  padding: 0.85rem;
  border: 1px solid #e1e8e5;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 3px 10px rgba(25, 56, 71, 0.045);
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease,
    box-shadow 0.18s ease, transform 0.18s ease;
}

.message-card:hover {
  transform: translateY(-1px);
  border-color: #bfd8cc;
  box-shadow: 0 7px 16px rgba(20, 74, 55, 0.08);
}

.message-card.non-letta {
  border-color: #a9d8c4;
  background: linear-gradient(140deg, #f2faf6 0%, #ffffff 78%);
}

.message-card.active-news {
  border-color: #5da986;
  box-shadow: 0 0 0 3px rgba(20, 111, 82, 0.1);
}

.message-card-icon {
  display: inline-flex;
  width: 2.35rem;
  height: 2.35rem;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #e9f7f0;
  color: var(--messages-green);
  font-size: 0.92rem;
}

.message-card-icon-notification {
  background: #edf4fb;
  color: #176fa8;
}

.message-type-aggiornamento {
  background: #fff4da;
  color: #986800;
}

.message-type-alert {
  background: #fdecee;
  color: #c62b43;
}

.message-type-evento {
  background: #ecebfb;
  color: #5d55b4;
}

.message-card-content {
  min-width: 0;
  text-align: left;
}

.message-card-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.6rem;
}

.message-card-notification .message-card-heading {
  padding-right: 1.1rem;
}

.message-card-heading h4 {
  min-width: 0;
  margin: 0;
  color: #18304a;
  font-size: 0.88rem;
  font-weight: 750;
  line-height: 1.28;
}

.message-card-heading time {
  flex: 0 0 auto;
  color: #84909e;
  font-size: 0.62rem;
  line-height: 1.35;
  white-space: nowrap;
}

.message-source {
  display: block;
  margin-top: 0.18rem;
  color: #19805e;
  font-size: 0.62rem;
  font-weight: 750;
  letter-spacing: 0.045em;
  text-transform: uppercase;
}

.message-card p {
  margin: 0.55rem 0 0;
  color: #617185;
  font-size: 0.76rem;
  line-height: 1.48;
  white-space: pre-wrap;
}

.btn-leggi-di-piu {
  display: inline-flex;
  margin-top: 0.65rem;
  padding: 0;
  align-items: center;
  gap: 0.45rem;
  border: 0;
  background: transparent;
  color: var(--messages-green);
  cursor: pointer;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 750;
}

.btn-leggi-di-piu i {
  font-size: 0.62rem;
  transition: transform 0.18s ease;
}

.btn-leggi-di-piu:hover i {
  transform: translateX(2px);
}

.notification-delete {
  position: absolute;
  top: 0.68rem;
  right: 0.55rem;
  width: 1.55rem;
  height: 1.55rem;
  border-radius: 999px;
  color: #9aa6b2;
  font-size: 0.68rem;
  transition: background 0.18s ease, color 0.18s ease;
}

.notification-delete:hover {
  background: #fdecee;
  color: #c9253f;
}

.no-news-display {
  display: flex;
  min-height: 16rem;
  padding: 2rem 1rem;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  text-align: center;
}

.no-news-display > span {
  display: inline-flex;
  width: 3.5rem;
  height: 3.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #edf7f2;
  color: var(--messages-green);
  font-size: 1.3rem;
}

.no-news-display h4 {
  margin: 0.85rem 0 0;
  color: #18304a;
  font-size: 0.98rem;
}

.no-news-display p {
  max-width: 15rem;
  margin: 0.35rem 0 0;
  color: #748294;
  font-size: 0.78rem;
  line-height: 1.5;
}

.modal-overlaynews {
  position: fixed;
  inset: 0;
  z-index: 2200;
  display: flex;
  padding: 1.25rem;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: rgba(10, 20, 26, 0.42);
  backdrop-filter: blur(3px);
}

.modal-contentnews {
  position: relative;
  width: min(34rem, 100%);
  max-height: min(38rem, calc(100dvh - 2.5rem));
  padding: 1.5rem;
  overflow-y: auto;
  box-sizing: border-box;
  border: 1px solid #dfe7e3;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 22px 55px rgba(10, 32, 39, 0.25);
  text-align: left;
}

.modal-label {
  display: inline-flex;
  padding: 0.32rem 0.58rem;
  border-radius: 999px;
  background: #eaf7f0;
  color: var(--messages-green);
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.035em;
  text-transform: uppercase;
}

.modal-contentnews h3 {
  margin: 0.85rem 2rem 0;
  color: #18304a;
  font-size: 1.25rem;
  line-height: 1.3;
}

.modal-contentnews p {
  margin: 1rem 0 0;
  color: #536477;
  font-size: 0.9rem;
  line-height: 1.65;
  white-space: pre-wrap;
}

.modal-contentnews small {
  display: block;
  margin-top: 1rem;
  color: #8692a0;
  font-size: 0.74rem;
}

.modal-close-icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 2rem;
  height: 2rem;
  border: 1px solid #e0e6e3;
  border-radius: 999px;
  background: #ffffff;
  color: #6f7c8a;
  font-size: 0.8rem;
}

.modal-close-icon:hover {
  background: #f1f4f3;
  color: #263b4b;
}

.btn-chiudinews {
  display: block;
  min-height: 2.35rem;
  margin: 1.25rem 0 0 auto;
  padding: 0.5rem 1rem;
  border: 0;
  border-radius: 8px;
  background: var(--messages-green);
  color: #ffffff;
  cursor: pointer;
  font: inherit;
  font-size: 0.8rem;
  font-weight: 750;
}

.btn-chiudinews:hover {
  background: var(--messages-green-dark);
}

.messages-drawer-enter-active,
.messages-drawer-leave-active {
  transition: transform 0.24s ease, opacity 0.2s ease;
}

.messages-drawer-enter,
.messages-drawer-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.messages-backdrop-enter-active,
.messages-backdrop-leave-active {
  transition: opacity 0.2s ease;
}

.messages-backdrop-enter,
.messages-backdrop-leave-to {
  opacity: 0;
}
</style>
